// extracted by mini-css-extract-plugin
module.exports = {"root":"InconsistentCabinBaggageInfo-module__root___D4W3l","text":"InconsistentCabinBaggageInfo-module__text___ogSJU"};